import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import SalesOrderList from "./pages/salesOrderList";
import VisualizeProductionProcess from "./pages/visualizeProductionProcess";
import Login from "./pages/login";
import ProtectedRoute from "./components/protectedRoute";

export function Routing() {
    return (
        <Router>
            <Routes>
                <Route index element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<Login />} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/sales-orders" element={<SalesOrderList />} />
                </Route>
            </Routes>
        </Router>
    )
}